import { ReactNode } from "react";
import { DataGridExportOptions } from "./types";
import { ExportToExcel } from "../ExportToExcel";
import dayjs from "dayjs";

export interface DataGridToolbarProps {
  title?: ReactNode;
  actions?: ReactNode;
  filters?: ReactNode;
  search?: ReactNode;
  exportOptions?: DataGridExportOptions;
}

export const DataGridToolbar = ({ title, actions, filters, search, exportOptions }: DataGridToolbarProps) => {
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
      <div>{title}</div>

      <div className="flex flex-wrap items-center gap-2">
        {actions}
        {exportOptions && !exportOptions.disabled && (
          <ExportToExcel
            title={exportOptions.exportTitle ?? `table_${dayjs().format("YYYYMMDD")}`}
            data={exportOptions.data}
            header={{ value: exportOptions.exportTitle ?? "" }}
            freeze={exportOptions.freeze ?? { xSplit: 1, ySplit: 3 }}
            loading={exportOptions.loading}
            disabled={exportOptions.disabled}
          />
        )}
        {search}
        {filters}
      </div>
    </div>
  );
};
